var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7467 6.0799C20.2667 6.0799 6.08008 20.2666 6.08008 37.7466C6.08008 55.2266 20.2667 69.4132 37.7467 69.4132C55.2267 69.4132 69.4134 55.2266 69.4134 37.7466C69.4134 20.2666 55.2267 6.0799 37.7467 6.0799ZM37.7467 63.0799C23.7817 63.0799 12.4134 51.7116 12.4134 37.7466C12.4134 23.7816 23.7817 12.4132 37.7467 12.4132C51.7117 12.4132 63.0801 23.7816 63.0801 37.7466C63.0801 51.7116 51.7117 63.0799 37.7467 63.0799Z",
    fill: "#C4C4C4",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.96,
    y: 22.8,
    width: 4.56,
    height: 31.92,
    fill: "#C4C4C4",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.28,
    y: 41.04,
    width: 4.56,
    height: 31.92,
    transform: "rotate(-90 21.28 41.04)",
    fill: "#C4C4C4",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f9b384323dd1248043d4780191f2cd34.svg";
export { ForwardRef as ReactComponent };